import * as React from 'react';
import GoogleButton from 'react-google-button'

import { History } from 'history'
import Cookies from 'universal-cookie';

import './InterestPage.css';

import logo from './Img/LoginLogo.png';

import * as api from './Api/User'

/*
 * gapi is global included in index.html
 * google auth init happens here too
 */
interface ILoginPageState {
    gapi: gapi.auth2.GoogleAuth | null
}

class LoginPage extends React.Component<any, ILoginPageState> {
    constructor(props:any) {
        super(props);
        this.state = {
            gapi: null
        };
    }

    public render() {
        const signInClickedProps = this.signInClicked.bind(this);
        const googleButtonOrNone = !!this.state.gapi 
            ? <GoogleButton className="LoginPage__sign-in-button" onClick={signInClickedProps} />
            : null

        return (
            <div className="verticalStretchWrapper">
                <div className="LoginPage">
                    <div className="LoginPage__login-box">
                        <img className="LoginPage__logo-box" src={logo} />

                        <div className="LoginPage__slogan-box">Revolutionise your meetings.</div>
                        { googleButtonOrNone }

                        <div className="LoginPage__footer">
                            {/* <div>Sign Up with Email</div> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public signInClicked() {
        if (!this.state.gapi) {
            console.log('this.state.gapi does not exist');
            return;
        }

        if (this.state.gapi.isSignedIn.get()) {
            console.log('this.state.gapi signed in');
            this.authoriseUser();
        } else {
            console.log('this.state.gapi not signed in');
            this.state.gapi.isSignedIn.listen(this.authoriseUser);
            this.state.gapi.signIn();
        }
    }

    public componentDidMount() {
        const waitOnGapi = setInterval(() => {
            if(!(window as any).gapi_init) {
                return;
            }

            clearInterval(waitOnGapi);
            this.setState({
                gapi: (window as any).gapi_init
            });
        }, 100);

        if ((window as any).drift) {
            (window as any).drift.on("ready", (driftApi: any) => {
                driftApi.widget.hide();
            });
        }
    }

    public authoriseUser = () => {
        const googleAuth = this.state.gapi as gapi.auth2.GoogleAuth;
        googleAuth.isSignedIn.listen(this.userSignedOut);

        const currentUser: gapi.auth2.GoogleUser = (googleAuth as gapi.auth2.GoogleAuth).currentUser.get();
        const profile: gapi.auth2.BasicProfile = currentUser.getBasicProfile(); // TODO: make this obsolete in the next version!!

        api.User.authorise(profile.getEmail(), profile.getImageUrl(), profile.getName(), (responseJSON) : void => {
            console.log(responseJSON);
            if (responseJSON.authorised) {
              this.setUserDataOnClient();
              (this.props.history as History).replace("/");
            } else {
              (this.props.history as History).replace("/interest");
            }
        });
    };

    public userSignedOut = () => {
        const googleAuth = this.state.gapi as gapi.auth2.GoogleAuth;
        googleAuth.isSignedIn.listen(this.authoriseUser);

        const cookies = new Cookies();
        cookies.remove('id_token');

        /* TODO: MAYBE LET SERVER KNOW IN THE FUTURE */
    };

    public setUserDataOnClient() : void {
        const googleAuth = this.state.gapi as gapi.auth2.GoogleAuth;
        const currentUser: gapi.auth2.GoogleUser = (googleAuth as gapi.auth2.GoogleAuth).currentUser.get();
        const authResponse: gapi.auth2.AuthResponse = currentUser.getAuthResponse();
        const profile: gapi.auth2.BasicProfile = currentUser.getBasicProfile(); // TODO: make this obsolete in the next version!!

        const cookies = new Cookies();
      // id_token's presence determines if the user is allowed to use the app or not
        cookies.set('id_token', authResponse.id_token, { path: '/' });

        window.localStorage.setItem('email',        profile.getEmail());
        window.localStorage.setItem('name',         profile.getName());
        window.localStorage.setItem('givenName',    profile.getGivenName());
        window.localStorage.setItem('familyName',   profile.getFamilyName());
        window.localStorage.setItem('imageUrl',     profile.getImageUrl());
    }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/LoginPage.tsx